import PageOrgStructure from '@/page/byl/org/structure/index'
import PageOrgReports from '@/page/byl/org/reports/index'
import PageOrgExternals from '@/page/byl/org/externals/index'
import PageOrgGroup from '@/page/byl/org/group/index'
import PageOrgResource from '@/page/byl/org/resource/model'
import PageOrgResourceList from '@/page/byl/org/resource/list'
import PageOrgRepo from '@/page/byl/org/repo/model'
import PageOrgRepoList from '@/page/byl/org/repo/list'
import PageOrgTag from '@/page/byl/org/tag/model'
import PageOrgTagList from '@/page/byl/org/tag/list'
import PageOrgMsg from '@/page/byl/org/msg/model'
import PageOrgMsgList from '@/page/byl/org/msg/list'
import PageOrgCourse from '@/page/byl/org/course/model'
import PageOrgCourseList from '@/page/byl/org/course/list'
import PageOrgLivePlay from '@/page/byl/org/livePlay/model'
import PageOrgLivePlayList from '@/page/byl/org/livePlay/list'
import PageOrgBanner from '@/page/byl/org/banner/model'
import PageOrgBannerList from '@/page/byl/org/banner/list'
import PageMenu from '@/page/byl/org/orgmenu/model'
import PageMenuList from '@/page/byl/org/orgmenu/list'
import PageOrgRole from '@/page/byl/org/role/model'
import PageOrgRoleList from '@/page/byl/org/role/list'
import PageOrgRoleDistributeList from '@/page/byl/org/role/distribute'
import PageRole from '@/page/byl/org/orgrole/model'
import PageRoleList from '@/page/byl/org/orgrole/list'
import PageRoleDistributeList from '@/page/byl/org/orgrole/distribute'
import PageDictList from '@/page/byl/org/orgdict/list'
import PageDict from '@/page/byl/org/orgdict/model'
import PageOrgExamPaper from '@/page/byl/org/examination_paper/model'
import PageOrgExamPaperList from '@/page/byl/org/examination_paper/list'
import PageOrgExamPaperScoreByTeacher from '@/page/byl/org/examination_paper/scoreByTeacher'
import PageOrgExamPaperScoreList from '@/page/byl/org/examination_paper/scoreList'
import PageOrgExamPaperAnswerList from '@/page/byl/org/examination_paper/answerList'
import PageOrgExamClassification_f from '@/page/byl/org/examination_paper/classification_f'
import PageOrgExamClassification_s from '@/page/byl/org/examination_paper/classification_s'
import PageOrgExamClassification_relate from '@/page/byl/org/examination_paper/classification_relate'

import PageOrgExamQuestionList from '@/page/byl/org/examination_question/list'
import PageOrgExamQ_ShortAnswer from '@/page/byl/org/examination_question/model_shortAnswer'
import PageOrgExamQ_Judgment from '@/page/byl/org/examination_question/model_judgment'
import PageOrgExamQ_Completion from '@/page/byl/org/examination_question/model_completion'
import PageOrgExamQ_Choice from '@/page/byl/org/examination_question/model_choice'
import PageOrgExamQ_MultipleChoice from '@/page/byl/org/examination_question/model_multipleChoice'

import PageOrgExamQClassification_f from '@/page/byl/org/examination_question/classification_f'
import PageOrgExamQClassification_s from '@/page/byl/org/examination_question/classification_s'
import PageOrgExamQClassification_relate from '@/page/byl/org/examination_question/classification_relate'

import PageOrgQuestionnaire from '@/page/byl/org/questionnaire/model'
import PageOrgQuestionnaireStat from '@/page/byl/org/questionnaire/statistics'
import PageOrgQuestionnaireList from '@/page/byl/org/questionnaire/list'

import PageOrgTeacher from '@/page/byl/org/teacher/model'
import PageOrgTeacherList from '@/page/byl/org/teacher/list'
import PageOrgEnroll from '@/page/byl/org/enroll/model'
import PageOrgEnrollList from '@/page/byl/org/enroll/list'
import PageOrgEnrollConfirm from '@/page/byl/org/enroll/confirm'
import PageOrgEnrollAudit from '@/page/byl/org/enroll/audit'
import PageOrgEnrollCheck from '@/page/byl/org/enroll/check'
import PageOrgEnrollSignin from '@/page/byl/org/enroll/signin'
import PageOrgCert from '@/page/byl/org/cert/model'
import PageOrgCertList from '@/page/byl/org/cert/list'
import PageOrgSendCert from '@/page/byl/org/cert/send'
import PageOrgCertRecord from '@/page/byl/org/cert/record'
import PageOrgPlan from '@/page/byl/org/plan/model'
import PageOrgPlanList from '@/page/byl/org/plan/list'
import PageOrgInformation from '@/page/byl/org/information/model'
import PageOrgInformationList from '@/page/byl/org/information/list'
import PageUserList from '@/page/byl/org/user/list'
import PageOrgInfo from '@/page/byl/org/orginfo/list'
import PageOrgAppList from '@/page/byl/org/appmgt/list'
import PageOrgApp from '@/page/byl/org/appmgt/model'
const routes = [
  {
    path: '/org/structure',
    name: '组织架构（电子继续教育）',
    component: PageOrgStructure,
    meta: {
      title: '组织架构',
      prefix: ''
    }
  },
  {
    path: '/org/reports',
    name: '报表预览（电子继续教育）',
    component: PageOrgReports,
    meta: {
      title: '报表预览',
      prefix: ''
    }
  },
  {
    path: '/org/externals',
    name: '外部系统',
    component: PageOrgExternals
  },
  {
    path: '/org/group',
    name: '小组管理（电子继续教育）',
    component: PageOrgGroup,
    meta: {
      title: '小组管理',
      prefix: ''
    }
  },
  {
    name: '消息管理(电子继续教育)',
    path: '/org/msgList',
    component: PageOrgMsgList,
    meta: {
      title: '消息管理',
      prefix: ''
    }
  },
  {
    name: '消息发送（电子继续教育）',
    path: '/org/msg',
    component: PageOrgMsg,
    meta: {
      title: '消息发送',
      prefix: ''
    }
  },
  {
    path: '/org/tag/:id',
    name: '标签详情(电子继续教育)',
    component: PageOrgTag,
    meta: {
      title: '标签管理',
      description: '标签管理',
      prefix: ''
    }
  },
  {
    path: '/org/tagList',
    name: '标签管理(电子继续教育)',
    component: PageOrgTagList,
    meta: {
      title: '标签管理',
      description: '标签管理',
      prefix: ''
    }
  },
  {
    path: '/org/resource/:id',
    name: '课件资源详情（电子继续教育）',
    component: PageOrgResource,
    meta: {
      title: '课件资源管理',
      description: '课件资源管理',
      prefix: ''
    }
  },
  {
    path: '/org/resourceList',
    name: '课件资源管理（电子继续教育）',
    component: PageOrgResourceList,
    meta: {
      title: '课件资源管理',
      description: '课件资源管理',
      prefix: ''
    }
  },
  {
    path: '/org/course/:id',
    name: '课程编辑（电子继续教育）',
    component: PageOrgCourse,
    meta: {
      title: '课程管理',
      description: '课程管理',
      prefix: ''
    }
  },
  {
    path: '/org/repo/:id',
    name: '知识库详情（电子继续教育）',
    component: PageOrgRepo,
    meta: {
      title: '知识库管理',
      description: '知识库管理',
      prefix: ''
    }
  },
  {
    path: '/org/repoList',
    name: '知识库管理（电子继续教育）',
    component: PageOrgRepoList,
    meta: {
      title: '知识库管理',
      description: '知识库管理',
      prefix: ''
    }
  },
  {
    path: '/org/courseList',
    name: '课程管理（电子继续教育）',
    component: PageOrgCourseList,
    meta: {
      title: '课程管理',
      description: '课程管理',
      prefix: ''
    }
  },
  {
    path: '/org/livePlay/:id',
    name: '直播编辑（电子继续教育）',
    component: PageOrgLivePlay,
    meta: {
      title: '直播管理',
      description: '直播管理',
      prefix: ''
    }
  },
  {
    path: '/org/livePlayList',
    name: '直播管理（电子继续教育）',
    component: PageOrgLivePlayList,
    meta: {
      title: '直播管理',
      description: '直播管理',
      prefix: ''
    }
  },
  {
    path: '/org/questionnaire/:id',
    name: '问卷编辑（电子继续教育）',
    component: PageOrgQuestionnaire,
    meta: {
      title: '问卷管理',
      description: '问卷管理',
      prefix: ''
    }
  },
  {
    path: '/org/questionnaireStat/:id',
    name: '问卷统计（电子继续教育）',
    component: PageOrgQuestionnaireStat,
    meta: {
      title: '问卷管理',
      description: '问卷管理',
      prefix: ''
    }
  },
  {
    path: '/org/questionnaireList',
    name: '问卷管理（电子继续教育）',
    component: PageOrgQuestionnaireList,
    meta: {
      title: '问卷管理',
      description: '问卷管理',
      prefix: ''
    }
  },
  {
    path: '/org/examPaper/:id',
    name: '考卷编辑（电子继续教育）',
    component: PageOrgExamPaper,
    meta: {
      title: '考卷管理',
      description: '考卷管理',
      prefix: ''
    }
  },
  {
    path: '/org/examPaperList',
    name: '考卷管理（电子继续教育）',
    component: PageOrgExamPaperList,
    meta: {
      title: '考卷管理',
      description: '考卷管理',
      prefix: ''
    }
  },
  {
    path: '/org/examPaperScoreList/:id',
    name: '考卷成绩一览（电子继续教育）',
    component: PageOrgExamPaperScoreList
  },
  {
    path: '/org/examPaperScoreByTeacher/:examId/:paperId',
    name: '老师评分（电子继续教育）',
    component: PageOrgExamPaperScoreByTeacher
  },
  {
    path: '/org/examPaperAnswerList/:id',
    name: '考卷成绩回答一览（电子继续教育）',
    component: PageOrgExamPaperAnswerList
  },
  {
    path: '/org/examClassification_f/:path/:id',
    name: '大分类管理（电子继续教育）',
    component: PageOrgExamClassification_f
  },
  {
    path: '/org/examClassification_s/:path/:id',
    name: '小分类管理（电子继续教育）',
    component: PageOrgExamClassification_s
  },
  {
    path: '/org/examClassification_relate/:path/:id/:fValue/:fLabel',
    name: '分类关联（电子继续教育）',
    component: PageOrgExamClassification_relate
  },
  {
    path: '/org/examQuestionList',
    name: '考题管理（电子继续教育）',
    component: PageOrgExamQuestionList,
    meta: {
      title: '考题管理',
      description: '考题管理',
      prefix: ''
    }
  },
  {
    path: '/org/examQuestionShortAnswer/:id',
    name: '简答题编辑（电子继续教育）',
    component: PageOrgExamQ_ShortAnswer,
    meta: {
      title: '简答题编辑',
      prefix: ''
    }
  },
  {
    path: '/org/examQuestionCompletion/:id',
    name: '填空题编辑（电子继续教育）',
    component: PageOrgExamQ_Completion,
    meta: {
      title: '填空题编辑',
      prefix: ''
    }
  },
  {
    path: '/org/examQuestionChoice/:id',
    name: '选择题编辑（电子继续教育）',
    component: PageOrgExamQ_Choice,
    meta: {
      title: '选择题编辑',
      prefix: ''
    }
  },
  {
    path: '/org/examQuestionJudgment/:id',
    name: '判断题编辑（电子继续教育）',
    component: PageOrgExamQ_Judgment,
    meta: {
      title: '判断题编辑',
      prefix: ''
    }
  },
  {
    path: '/org/examQuestionMultipleChoice/:id',
    name: '多选题编辑（电子继续教育）',
    component: PageOrgExamQ_MultipleChoice,
    meta: {
      title: '多选题编辑',
      prefix: ''
    }
  },
  {
    path: '/org/examQClassification_f/:path/:id',
    name: '考题大分类管理',
    component: PageOrgExamQClassification_f
  },
  {
    path: '/org/examQClassification_s/:path/:id',
    name: '考题小分类管理',
    component: PageOrgExamQClassification_s
  },
  {
    path: '/org/examQClassification_relate/:path/:id/:fValue/:fLabel',
    name: '考题分类关联',
    component: PageOrgExamQClassification_relate
  },
  {
    name: '培训计划管理（霍尼韦尔）',
    path: '/org/planList',
    component: PageOrgPlanList,
    meta: {
      title: '培训计划管理',
      description: '培训计划管理',
      prefix: ''
    }
  },
  {
    name: '培训计划详情（电子继续教育）',
    path: '/org/plan/:id',
    component: PageOrgPlan,
    meta: {
      title: '培训计划管理',
      description: '培训计划管理',
      prefix: ''
    }
  },
  {
    name: '报名管理（电子继续教育）',
    path: '/org/enrollList',
    component: PageOrgEnrollList,
    meta: {
      title: '报名管理',
      description: '报名管理',
      prefix: ''
    }
  },
  {
    name: '报名管理详情（电子继续教育）',
    path: '/org/enroll/:id',
    component: PageOrgEnroll,
    meta: {
      title: '报名管理',
      description: '报名管理',
      prefix: ''
    }
  },
  {
    name: '报名人员列表（电子继续教育）',
    path: '/org/enrollConfirm/:id',
    component: PageOrgEnrollConfirm,
    meta: {
      title: '报名管理',
      description: '报名管理',
      prefix: ''
    }
  },
  {
    name: '报名审核（电子继续教育）',
    path: '/org/enrollAudit/:id',
    component: PageOrgEnrollAudit,
    meta: {
      title: '报名审核',
      description: '报名审核',
      prefix: ''
    }
  },
  {
    name: '签到情况（电子继续教育）',
    path: '/org/enrollSignin/:id',
    component: PageOrgEnrollSignin ,
    meta: {
      title: '签到情况',
      description: '签到情况',
      prefix: ''
    }
  },
  {
    name: '学习情况（电子继续教育）',
    path: '/org/enrollCheck/:id',
    component: PageOrgEnrollCheck,
    meta: {
      title: '学习情况',
      description: '学习情况',
      prefix: ''
    }
  },
  {
    name: '证书管理（电子继续教育）',
    path: '/org/certList',
    component: PageOrgCertList,
    meta: {
      title: '证书管理',
      description: '证书管理',
      prefix: ''
    }
  },
  {
    name: '证书管理详情（电子继续教育）',
    path: '/org/cert/:id',
    component: PageOrgCert,
    meta: {
      title: '证书管理',
      description: '证书管理',
      prefix: ''
    }
  },
  {
    name: '发证书(电子继续教育)',
    path: '/org/sendcert',
    component: PageOrgSendCert,
    meta: {
      title: '证书管理',
      description: '证书管理',
      prefix: ''
    }
  },
  {
    name: '讲师管理（电子继续教育）',
    path: '/org/teacherList',
    component: PageOrgTeacherList,
    meta: {
      title: '讲师管理',
      description: '讲师管理',
      prefix: ''
    }
  },
  {
    name: '讲师管理详情（电子继续教育）',
    path: '/org/teacher/:id',
    component: PageOrgTeacher,
    meta: {
      title: '讲师管理',
      description: '讲师管理',
      prefix: ''
    }
  },
  {
    name: '公告管理（电子继续教育）',
    path: '/org/informationList',
    component: PageOrgInformationList,
    meta: {
      title: '公告管理',
      description: '公告管理',
      prefix: ''
    }
  },
  {
    name: '公告管理详情（电子继续教育）',
    path: '/org/information/:id',
    component: PageOrgInformation,
    meta: {
      title: '公告管理',
      description: '公告管理',
      prefix: ''
    }
  },
  {
    path: '/org/bannerList',
    name: '推荐列表（电子继续教育）',
    component: PageOrgBannerList,
    meta: {
      title: '推荐管理',
      description: '推荐管理',
      prefix: ''
    }
  },
  {
    path: '/org/banner/:id',
    name: '推荐详情（电子继续教育）',
    component: PageOrgBanner,
    meta: {
      title: '推荐管理',
      description: '推荐管理',
      prefix: ''
    }
  },
  {
    path: '/org/menuList',
    name: '菜单管理（电子继续教育）',
    component: PageMenuList,
    meta: {
      title: '菜单管理',
      description: '菜单管理',
      prefix: ''
    }
  },
  {
    path: '/org/menu/:id/:parentId',
    name: '菜单管理详情（电子继续教育）',
    component: PageMenu,
    meta: {
      title: '菜单管理',
      description: '菜单管理',
      prefix: ''
    }
  },
  {
    path: '/org/orgroleList',
    name: '机构角色管理（电子继续教育）',
    component: PageOrgRoleList,
    meta: {
      title: '机构角色管理',
      description: '机构角色管理',
      prefix: ''
    }
  },
  {
    path: '/org/orgrole/:id',
    name: '机构角色编辑(电子继续教育)',
    component: PageOrgRole,
    meta: {
      title: '机构角色编辑',
      description: '机构角色编辑',
      prefix: ''
    }
  },
  {
    path: '/org/orgrole/distribute/:id',
    name: '机构角色分配管理(电子继续教育)',
    component: PageOrgRoleDistributeList,
    meta: {
      title: '机构角色分配管理',
      description: '机构角色分配管理',
      prefix: ''
    }
  },
  {
    path: '/org/roleList',
    name: '角色管理（电子继续教育）',
    component: PageRoleList,
    meta: {
      title: '角色管理',
      description: '角色管理',
      prefix: ''
    }
  },
  {
    path: '/org/role/:id',
    name: '角色管理详情（电子继续教育）',
    component: PageRole,
    meta: {
      title: '角色管理',
      description: '角色管理',
      prefix: ''
    }
  },
  {
    path: '/org/role/distribute/:id',
    name: '角色管理分配（电子继续教育）',
    component: PageRoleDistributeList,
    meta: {
      title: '角色管理',
      description: '角色管理',
      prefix: ''
    }
  },
  {
    path: '/org/dictList',
    name: '字典管理（电子继续教育）',
    component: PageDictList,
    meta: {
      title: '字典管理',
      description: '字典管理',
      prefix: ''
    }
  },
  {
    path: '/org/dict/:id',
    name: '字典管理详情（电子继续教育）',
    component: PageDict,
    meta: {
      title: '字典管理',
      description: '字典管理',
      prefix: ''
    }
  },
  {
    path: '/org/userList',
    name: '用户管理（电子继续教育）',
    component: PageUserList,
    meta: {
      title: '用户管理',
      description: '用户管理',
      prefix: ''
    }
  },
  {
    path: '/org/entinfo',
    name: '机构信息管理(电子继续教育)',
    component: PageOrgInfo,
    meta: {
      title: '机构信息管理',
      description: '机构信息管理',
      prefix: ''
    }
  },
  {
    path: '/org/appmgtList',
    name: 'APP管理',
    component: PageOrgAppList,
    meta: {
      title: 'APP管理',
      description: 'APP管理',
      prefix: ''
    }
  },
  {
    path: '/org/appmgt/:id',
    name: 'APP版本编辑',
    component: PageOrgApp,
    meta: {
      title: 'APP版本编辑',
      description: 'APP版本编辑',
      prefix: ''
    }
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routers/org.js